// extracted by mini-css-extract-plugin
export var carrierNotice = "_k4-5";
export var carrierNoticePlaceholder = "_k4-6";
export var deliveryRow = "_k4-c";
export var fixedHeight = "_k4-4";
export var freightLogo = "_k4-b";
export var fullWidth = "_k4-3";
export var priceColumn = "_k4-7";
export var radioSelected = "_k4-9";
export var radioUnselected = "_k4-8";
export var selectedOption = "_k4-2";
export var selectedOptionContainer = "_k4-1";
export var selection = "_k4-0";
export var tallSkeletonText = "_k4-a";